import * as React from "react"
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import cs from "classnames"

import styles from "./SignaturePlugin.module.scss"

interface Props {
  /**
   * HTML that is rendered with dangerouslySetInnerHTML()
   */
  signature?: string | null
  className?: string
  onOpenChange?: (open: boolean) => void
}

export const SignaturePlugin = ({ signature, className, onOpenChange }: Props) => {
  const handleOpenChange = (_: unknown, open: boolean) => onOpenChange?.(open)

  if (!signature) return null

  return (
    <Accordion className={cs(styles.root, className)} onChange={handleOpenChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>Your Signature</AccordionSummary>
      <AccordionDetails>
        <div className={styles.signature} dangerouslySetInnerHTML={{ __html: signature }} />
      </AccordionDetails>
    </Accordion>
  )
}
